import { toQuotedString, createIssuesUrl } from '@atlassian/jira-common-jql/src/helpers.tsx';

// When moving issues from a version to a new version on release we do this by the resolution field, not the issueStatus
export const getUnresolvedIssuesInVersionJql = (
	projectKey: string,
	versionName: string,
): string => {
	const jql = `project = ${toQuotedString(projectKey)} AND fixVersion = ${toQuotedString(
		versionName,
	)} AND resolution is EMPTY`;
	return createIssuesUrl(jql);
};

export const getResolvedIssuesInVersionJql = (projectKey: string, versionName: string): string =>
	createIssuesUrl(
		`project = ${toQuotedString(projectKey)} AND fixVersion = ${toQuotedString(
			versionName,
		)} AND resolution is NOT EMPTY`,
	);
